// Centralized pricing configuration (single source of truth).
// Update numbers here only — never hardcode prices in components.

export const PRO = {
  name: 'Pro',
  credits: '500 Kalki Credits / month',
  tagline: 'For active traders who want serious intelligence.',
  plans: [
    { id: 'monthly', label: 'Monthly Plan', price: '$139', unit: '/mo', badge: 'Flexible', save: null },
    { id: 'quarterly', label: 'Quarterly Plan', price: '$399', unit: '/3 mo', badge: 'Save 4%', save: 'Save 4%', popular: true },
    { id: 'annual', label: 'Annual Plan', price: '$1,499', unit: '/yr', badge: 'Save 10%', save: 'Save 10%' },
  ],
  features: [
    '500 Kalki Credits included every month',
    'AI market, technical & pattern scans',
    'Strategy engine & backtesting',
    'Trade terminal & automated journal',
    'Portfolio analytics & risk visibility',
  ],
  checkout: { stripe: 'PRO_STRIPE', crypto: 'PRO_CRYPTO' },
};

export const PRO_MAX = {
  name: 'Pro Max',
  credits: '1000 Kalki Credits / month',
  tagline: 'Maximum intelligence, capacity and automation.',
  plans: [
    { id: 'monthly', label: 'Monthly Plan', price: '$179', unit: '/mo', badge: 'Flexible', save: null },
    { id: 'quarterly', label: 'Quarterly Plan', price: '$499', unit: '/3 mo', badge: 'Save 7%', save: 'Save 7%', popular: true },
    { id: 'annual', label: 'Annual Plan', price: '$1,799', unit: '/yr', badge: 'Save 16%', save: 'Save 16%' },
  ],
  features: [
    '1000 Kalki Credits included every month',
    'Everything in Pro',
    'Higher scan & automation limits',
    'Priority signal processing',
    'Advanced portfolio & risk analytics',
  ],
  checkout: { stripe: 'PRO_MAX_STRIPE', crypto: 'PRO_MAX_CRYPTO' },
};

export const PLANS = { pro: PRO, proMax: PRO_MAX };

export const CRYPTO_METHODS = ['USDT', 'BTC', 'ETH'];

// Exchange Account Tiers — connect exchange accounts, monthly subscription.
export const EXCHANGE_TIERS = [
  { name: 'Tier 1', price: 'Free', unit: '', accounts: '1 exchange account', highlight: false },
  { name: 'Tier 2', price: '$79', unit: '/mo', accounts: '2 exchange accounts', highlight: false },
  { name: 'Tier 3', price: '$109', unit: '/mo', accounts: '3 exchange accounts', highlight: true },
  { name: 'Tier 4', price: '$149', unit: '/mo', accounts: '5 exchange accounts', highlight: false },
];

// Kalki Credit packs (one-time top-ups).
export const CREDIT_PACKS = [
  { credits: '500', price: '$29', rate: '17.2 / $', best: false },
  { credits: '750', price: '$39', rate: '19.2 / $', best: false },
  { credits: '1,000', price: '$49', rate: '20.4 / $', best: true },
  { credits: '2,500', price: '$99', rate: '25.3 / $', best: false },
  { credits: '5,000', price: '$149', rate: '33.6 / $', best: false },
  { credits: '10,000', price: '$249', rate: '40.2 / $', best: false },
];

export const CREDIT_USES = ['Backtesting', 'Pattern Scan', 'Technical Scan', 'AI Market Analysis'];
